import {Component, OnInit} from '@angular/core';
import {BdDunningTypeBaseComponent} from '../base/bd-dunning-type-base.component';

/**
 * Side view of the DunningType object component (`uiMode = 'side' | 'mini-side'`), layer 3 of the
 * three-layer OBC pattern.
 *
 * It renders the same navigation points as {@link BdDunningTypeFullComponent} with ONE exception:
 * `nodeView` is removed. The canvas of `mvs-config-node-view` is laid out in absolute pixels and
 * declares `min-height: 600px` with a hard `width: 100%` pan area; in a narrow side panel it is not
 * operable — nodes overlap the panel edge and the pan/zoom gestures fight the panel's own scrolling.
 * Offering a navigation point that cannot work is worse than not offering it.
 *
 * Removing the entry also produces the required deep-link behaviour for free: with `nodeView` absent
 * from `navigationItems`, `ObjectBaseModeComponent` finds no match for `?navItem=nodeView` and falls
 * back to the `default` entry — `overview`. The template's closing `@else` branch repeats that
 * fallback defensively, so an unknown action can never render an empty panel.
 */
@Component({
    selector: 'bd-dunning-type-side',
    templateUrl: './bd-dunning-type-side.component.html',
    styleUrls: ['./bd-dunning-type-side.component.scss'],
    standalone: false
})
export class BdDunningTypeSideComponent extends BdDunningTypeBaseComponent implements OnInit {

    ngOnInit() {
        // Derive the side navigation from the shared list so labels, tooltips and icons stay
        // defined in exactly one place. The base class builds a fresh array per instance, so the
        // full view is unaffected. This MUST happen before super.ngOnInit(), which resolves the
        // default entry and the ?navItem= / ?sideNavItem= query parameters against this list.
        this.navigationItems = this.navigationItems.filter(item => item.action !== 'nodeView');

        super.ngOnInit();
    }

}
